export default {
  getError500: state => {
    return {
      options: state.options,
      active: state.active
    }
  },

  jsonErrors: state => state.jsonErrors
};
